import { renderLocationSidebar } from './locationSidebar';

export const NEWS_CREATE_TEMPLATE = `
<div class="flex min-h-screen overflow-hidden bg-background-light">
${renderLocationSidebar('news')}
<main class="ml-64 flex-1">
  <div id="news-form-alert" class="hidden max-w-7xl mx-auto mt-6 mb-0 px-4 py-3 rounded-lg border text-sm"></div>
  <div class="max-w-7xl mx-auto px-6 py-8 pb-32">
    <div class="mb-8">
      <nav class="flex items-center gap-2 text-sm text-slate-500 mb-2">
        <a class="hover:text-primary" href="/news">News</a>
        <span class="material-symbols-outlined text-xs">chevron_right</span>
        <span id="news-form-breadcrumb" class="text-slate-900 font-medium">Create News Post</span>
      </nav>
      <div class="flex items-end justify-between">
        <div>
          <h1 id="news-form-title" class="text-3xl font-black text-slate-900 tracking-tight">Create News Post</h1>
          <p class="text-slate-500 mt-1">Draft your latest journey story and news updates for the community.</p>
        </div>
        <div class="flex items-center gap-3">
          <div id="news-form-mode-badge" class="flex items-center gap-2 px-3 py-1.5 bg-yellow-100 text-yellow-700 rounded-lg text-xs font-bold uppercase tracking-wider">
            <span class="material-symbols-outlined text-sm">edit_note</span>
            Draft Mode
          </div>
        </div>
      </div>
    </div>

    <form id="news-form" class="grid grid-cols-1 lg:grid-cols-12 gap-8">
      <div class="lg:col-span-8 space-y-8">
        <section class="bg-white rounded-xl border border-slate-200 shadow-sm p-6 space-y-6">
          <div>
            <label class="block text-sm font-semibold text-slate-700 mb-1">Title <span class="text-red-500">*</span></label>
            <input id="news-title" class="w-full px-4 py-3 rounded-lg border border-slate-200 focus:border-primary focus:ring-2 focus:ring-primary/10 text-lg font-bold" placeholder="Enter post title..." type="text"/>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label class="block text-sm font-semibold text-slate-700 mb-1">Slug</label>
              <div class="flex">
                <span class="inline-flex items-center px-3 rounded-l-lg border border-r-0 border-slate-200 bg-slate-50 text-slate-500 text-sm">motojourney.com/news/</span>
                <input id="news-slug" class="flex-1 px-4 py-2 rounded-r-lg border border-slate-200 focus:border-primary focus:ring-2 focus:ring-primary/10 text-sm" type="text"/>
              </div>
            </div>
            <div>
              <label class="block text-sm font-semibold text-slate-700 mb-1">Category <span class="text-red-500">*</span></label>
              <select id="news-category" class="w-full px-4 py-2 rounded-lg border border-slate-200 focus:border-primary focus:ring-2 focus:ring-primary/10 text-sm">
                <option value="">Select Category</option>
              </select>
            </div>
          </div>
          <div>
            <label class="block text-sm font-semibold text-slate-700 mb-1">Excerpt</label>
            <textarea id="news-excerpt" class="w-full px-4 py-2 rounded-lg border border-slate-200 focus:border-primary focus:ring-2 focus:ring-primary/10 text-sm" placeholder="Brief summary for list views..." rows="2"></textarea>
          </div>
          <div>
            <label class="block text-sm font-semibold text-slate-700 mb-1">Description</label>
            <textarea id="news-description" class="w-full px-4 py-2 rounded-lg border border-slate-200 focus:border-primary focus:ring-2 focus:ring-primary/10 text-sm" placeholder="Short description..." rows="3"></textarea>
          </div>
          <div>
            <label class="block text-sm font-semibold text-slate-700 mb-1">Content</label>
            <textarea id="news-content" class="w-full px-4 py-4 border border-slate-200 rounded-lg focus:ring-primary focus:border-primary text-base leading-relaxed" placeholder="Start writing your journey..." rows="12"></textarea>
          </div>
          <div>
            <label class="block text-sm font-semibold text-slate-700 mb-1">Structured Content (blocks_v1)</label>
            <div id="news-content-blocks-editor" class="rounded-lg border border-slate-200 p-3 bg-white"></div>
            <textarea id="news-content-blocks" class="hidden" rows="1"></textarea>
          </div>
        </section>

        <section class="bg-white rounded-xl border border-slate-200 shadow-sm p-6">
          <h3 class="text-lg font-bold text-slate-900 mb-4 flex items-center gap-2">
            <span class="material-symbols-outlined text-primary">image</span>
            Media & Gallery
          </h3>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div class="md:col-span-1">
              <label class="block text-sm font-semibold text-slate-700 mb-2">Cover Image</label>
              <label for="news-cover-file" class="relative aspect-video rounded-lg bg-slate-100 border-2 border-dashed border-slate-300 flex flex-col items-center justify-center text-slate-400 group cursor-pointer hover:border-primary hover:bg-primary/5 transition-all">
                <span class="material-symbols-outlined text-3xl mb-1">cloud_upload</span>
                <span class="text-xs font-medium">Click to upload</span>
              </label>
              <input id="news-cover-file" type="file" class="hidden" accept="image/*"/>
              <p id="news-cover-name" class="text-xs text-slate-500 mt-2"></p>
              <div id="news-cover-preview" class="mt-2"></div>
            </div>
            <div class="md:col-span-2">
              <label class="block text-sm font-semibold text-slate-700 mb-2">Gallery Items</label>
              <div class="grid grid-cols-2 sm:grid-cols-3 gap-3">
                <label for="news-gallery-files" class="aspect-square rounded-lg border-2 border-dashed border-slate-200 flex items-center justify-center text-slate-400 hover:text-primary hover:border-primary cursor-pointer transition-colors">
                  <span class="material-symbols-outlined">add</span>
                </label>
                <input id="news-gallery-files" type="file" class="hidden" accept="image/*" multiple/>
                <div id="news-gallery-preview" class="contents"></div>
              </div>
            </div>
          </div>
        </section>

        <section class="bg-white rounded-xl border border-slate-200 shadow-sm p-6 space-y-6">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label class="block text-sm font-semibold text-slate-700 mb-1">Tags</label>
              <select id="news-tags" multiple class="w-full px-4 py-2 rounded-lg border border-slate-200 focus:border-primary focus:ring-2 focus:ring-primary/10 text-sm min-h-32"></select>
            </div>
            <div class="space-y-4">
              <div>
                <label class="block text-sm font-semibold text-slate-700 mb-1">External URL</label>
                <input id="news-external-url" class="w-full px-4 py-2 rounded-lg border border-slate-200 focus:border-primary focus:ring-2 focus:ring-primary/10 text-sm" placeholder="https://..." type="url"/>
              </div>
              <div>
                <label class="block text-sm font-semibold text-slate-700 mb-1">Source Name</label>
                <input id="news-source-name" class="w-full px-4 py-2 rounded-lg border border-slate-200 focus:border-primary focus:ring-2 focus:ring-primary/10 text-sm" placeholder="Source name" type="text"/>
              </div>
              <div>
                <label class="block text-sm font-semibold text-slate-700 mb-1">Source URL</label>
                <input id="news-source-url" class="w-full px-4 py-2 rounded-lg border border-slate-200 focus:border-primary focus:ring-2 focus:ring-primary/10 text-sm" placeholder="https://source..." type="url"/>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-8 py-4 border-y border-slate-100">
            <label class="flex items-center gap-3 cursor-pointer group">
              <input id="news-featured" class="rounded text-primary focus:ring-primary border-slate-300" type="checkbox"/>
              <span class="text-sm font-bold text-slate-700 group-hover:text-primary transition-colors">Featured Post</span>
            </label>
            <label class="flex items-center gap-3 cursor-pointer group">
              <input id="news-pinned" class="rounded text-primary focus:ring-primary border-slate-300" type="checkbox"/>
              <span class="text-sm font-bold text-slate-700 group-hover:text-primary transition-colors">Pinned to Top</span>
            </label>
          </div>
          <div class="space-y-4">
            <h4 class="text-sm font-bold text-slate-900 uppercase tracking-widest flex items-center gap-2">
              <span class="material-symbols-outlined text-base">search</span>
              Search Engine Optimization (SEO)
            </h4>
            <div class="grid grid-cols-1 gap-4">
              <div>
                <label class="block text-xs font-bold text-slate-500 mb-1 uppercase">SEO Title</label>
                <input id="news-seo-title" class="w-full px-4 py-2 rounded-lg border border-slate-200 focus:border-primary focus:ring-2 focus:ring-primary/10 text-sm" placeholder="Custom SEO title..." type="text"/>
              </div>
              <div>
                <label class="block text-xs font-bold text-slate-500 mb-1 uppercase">SEO Description</label>
                <textarea id="news-seo-description" class="w-full px-4 py-2 rounded-lg border border-slate-200 focus:border-primary focus:ring-2 focus:ring-primary/10 text-sm" placeholder="Custom meta description..." rows="2"></textarea>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div class="lg:col-span-4">
        <div class="space-y-6 sticky top-8">
          <section class="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
            <div class="bg-slate-50 border-b border-slate-200 px-5 py-4 flex items-center justify-between">
              <h3 class="font-bold text-slate-900">Post Summary</h3>
              <span id="news-summary-status" class="px-2 py-1 bg-yellow-100 text-yellow-700 text-[10px] font-black rounded uppercase tracking-tighter">Draft</span>
            </div>
            <div class="p-5 space-y-4">
              <div class="flex items-center justify-between"><span class="text-sm text-slate-500">Status</span><select id="news-status" class="text-sm font-semibold text-slate-900 bg-transparent border-none p-0 focus:ring-0 text-right"><option value="draft">Draft</option><option value="pending_review">Pending Review</option><option value="published">Published</option><option value="archived">Archived</option></select></div>
              <div>
                <label class="block text-xs font-bold text-slate-500 mb-2 uppercase">Review Comment</label>
                <textarea id="news-review-comment" class="w-full px-3 py-2 bg-slate-50 rounded-lg border border-slate-200 focus:border-primary focus:ring-2 focus:ring-primary/10 text-xs" placeholder="Notes for the editor..." rows="3"></textarea>
              </div>
            </div>
          </section>

          <section class="bg-white rounded-xl border border-slate-200 shadow-sm p-5">
            <h4 class="text-xs font-bold text-slate-500 mb-4 uppercase tracking-widest">Google Preview</h4>
            <div class="space-y-1">
              <div id="news-preview-title" class="text-blue-700 text-lg truncate">Article title preview</div>
              <div id="news-preview-url" class="text-green-700 text-sm truncate">motojourney.com/news/slug</div>
              <div id="news-preview-description" class="text-slate-600 text-sm line-clamp-2">Description preview</div>
            </div>
          </section>
        </div>
      </div>
    </form>
  </div>

  <footer class="fixed bottom-0 left-64 right-0 bg-white border-t border-slate-200 shadow-[0_-4px_20px_rgba(0,0,0,0.05)] z-50">
    <div class="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
      <div class="flex items-center gap-2 text-slate-400">
        <span class="material-symbols-outlined text-sm">sync</span>
        <span id="news-last-saved" class="text-xs font-medium">Ready</span>
      </div>
      <div class="flex items-center gap-3">
        <a href="/news" class="px-5 py-2.5 text-slate-600 hover:text-slate-900 font-bold text-sm transition-colors">Cancel</a>
        <div class="h-6 w-px bg-slate-200 mx-2"></div>
        <button id="news-import-json" class="px-5 py-2.5 border border-slate-200 text-slate-700 rounded-lg font-bold text-sm hover:bg-slate-50 transition-colors inline-flex items-center gap-2" type="button">
          <span class="material-symbols-outlined text-sm">upload_file</span>
          Import JSON
        </button>
        <button id="news-save-draft" class="px-5 py-2.5 border border-slate-200 text-slate-700 rounded-lg font-bold text-sm hover:bg-slate-50 transition-colors" type="button">Save Draft</button>
        <button id="news-save-changes" class="px-5 py-2.5 border border-primary text-primary rounded-lg font-bold text-sm hover:bg-primary/5 transition-colors" type="button">Save Changes</button>
        <button id="news-publish" class="px-8 py-2.5 bg-primary text-white rounded-lg font-bold text-sm hover:bg-primary/90 shadow-lg shadow-primary/20 transition-all flex items-center gap-2" type="button">
          Publish Now
          <span class="material-symbols-outlined text-sm">send</span>
        </button>
      </div>
    </div>
  </footer>
</main>
</div>
`;
